var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPassInvis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99837 3.34049C9.83837 3.34049 11.3317 4.83383 11.3317 6.67383C11.3317 7.10383 11.245 7.51383 11.095 7.89049L13.045 9.8405C14.0517 9.00049 14.845 7.91383 15.335 6.67383C14.1784 3.74716 11.335 1.67383 7.99837 1.67383C7.06504 1.67383 6.17171 1.84049 5.34171 2.14049L6.78171 3.57716C7.15837 3.43049 7.56837 3.34049 7.99837 3.34049ZM1.33171 1.52383L2.85171 3.04383L3.15504 3.34716C2.05504 4.20716 1.18504 5.35049 0.665039 6.67383C1.81837 9.6005 4.66504 11.6738 7.99837 11.6738C9.0317 11.6738 10.0184 11.4738 10.9217 11.1105L11.205 11.3938L13.1484 13.3405L13.9984 12.4938L2.18171 0.673828L1.33171 1.52383ZM5.01837 5.20716L6.04837 6.23716C6.01837 6.3805 5.99837 6.52383 5.99837 6.67383C5.99837 7.77716 6.89504 8.67383 7.99837 8.67383C8.14837 8.67383 8.29171 8.65383 8.4317 8.62383L9.46171 9.65383C9.01837 9.87383 8.52504 10.0072 7.99837 10.0072C6.15837 10.0072 4.66504 8.51383 4.66504 6.67383C4.66504 6.14716 4.79837 5.65383 5.01837 5.20716ZM7.88837 4.68383L9.98837 6.78383L9.99837 6.67383C9.99837 5.5705 9.10171 4.67383 7.99837 4.67383L7.88837 4.68383Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassInvis);
export default __webpack_public_path__ + "static/media/PassInvis.25dfad4e.svg";
export { ForwardRef as ReactComponent };